import React from 'react';
import { Text } from 'react-native';
import { Platform } from 'src/libs/platform';
import Cross from 'src/assets/icons/x.svg';
import { PanelHeaderButton, PanelHeaderButtonProps } from './PanelHeaderButton';

export const PanelHeaderClose: React.FC<PanelHeaderButtonProps> = ({ children, ...props }) => (
  <PanelHeaderButton {...props}>
    {Platform.OS === 'ios' ? <Text>{children}</Text> : <Cross />}
  </PanelHeaderButton>
);
